import StencilHTMLElement from "./stencil-element";

class ProductVirtualOptionsPicker extends StencilHTMLElement {
  name = "ProductVirtualOptionsPicker";
  productDetails;
  productOptionsPicker;

  constructor() {
    super();
  }

  connectedCallback() {
    // STENCIL v2 version
    // this.productDetails = this.closest("product-details");
    this.productDetails = this.closest(".product-container");

    // STENCIL v2 version
    // this.productOptionsPicker = this.productDetails?.querySelector("product-options-picker");
    this.productOptionsPicker = this.productDetails?.querySelector("#variant-select");

    // Set the default values of the virtual pickers to match the real pickers
    // (i.e. the default variant on pageload)
    this.setVirtualPickersFromRealPickers();

    // Force an initial update of non-primary virtual product option pickers to
    // ensure the right values are shown initially - for selects
    this.querySelectorAll("[data-presentation='dropdown'] [data-virtual-primary-option='true']").forEach(picker => {
      this.updateRelatedVirtualPickers(picker);
    });

    // Force an initial update of non-primary virtual product option pickers to
    // ensure the right values are shown initially - for checked radio buttons
    this.querySelectorAll("[data-presentation='buttons'] *:checked, [data-presentation='swatches'] *:checked").forEach(picker => {
      this.updateRelatedVirtualPickers(picker);
    });

    this.addEventListener("change", this.onVirtualPickerChange.bind(this));

    this.firstElementChild.style.opacity = 1;
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onVirtualPickerChange);
  }

  /**
   * Handle change events on the virtual product option pickers
   * 
   * @param {Event} e 
   */
  onVirtualPickerChange(e) {
    const changedPicker = e.target;

    // Only update 'related' virtual product option pickers if a 'primary' one
    // changes (because we don't want changes in non-primary pickers to affect
    // the primary ones)
    this.updateRelatedVirtualPickers(changedPicker);

    // Update the real product options' pickers to match the currently selected
    // virtual product options' pickers
    switch(changedPicker.tagName) {
      case "SELECT":
        this.setRealPickerValue(changedPicker.dataset.realOptionName, changedPicker.selectedOptions[0].dataset.realOptionValue);
        break;
      case "INPUT":
        this.setRealPickerValue(changedPicker.dataset.realOptionName, changedPicker.nextElementSibling.dataset.realOptionValue);
        break;
    }
  }

  /**
   * Force the real product options' pickers to match the currently selected
   * virtual product options' pickers (triggering the standard variant change)
   *
   * @param {String} realOptionName e.g. "Pillow 1"
   * @param {String} realOptionValue e.g. "Original / Red"
   */
  setRealPickerValue(realOptionName, realOptionValue) {
    // console.log(this.logPrefix, `Setting real option '${realOptionName}' to '${realOptionValue}'`);
    // console.log(this.logPrefix, `Selector`, `fieldset[data-name='${realOptionName}'] label[data-value='${realOptionValue}']`);
    this.productOptionsPicker.querySelector(`fieldset[data-name='${realOptionName}'] label[data-value='${realOptionValue}']`).click();
  }

  /**
   * Set the virtual product options' pickers to match the currently selected
   * real product options' pickers (i.e. the standard product option buttons)
   */
  setVirtualPickersFromRealPickers() {
    this.productOptionsPicker.querySelectorAll("fieldset").forEach(fieldset => {
      console.log(this.logPrefix, fieldset);
      const position = fieldset.dataset.position;
      const selectedValue = fieldset.querySelector("input[checked]").value;
      const selectedValueParts = selectedValue.split(" / ");
      if(selectedValueParts.length > 1) {
        selectedValueParts.forEach((value, i) => {
          const virtualPickers = Array.from(this.querySelectorAll(`[data-real-option-position='${position}'][data-virtual-option-index='${i}']`));
          const pickerType = virtualPickers[0].tagName;
          if(pickerType == "SELECT") { // It's a select
            //
            // TODO: This is broken, needs updated like below
            //
            virtualPickers[0].value = value;
          } else { // It's something else - e.g. buttons / swatches
            const applicableVirtualPicker = virtualPickers.filter(picker => {
              const pickerLabel = picker.nextElementSibling;
              const pickerLabelRealOptionValue = pickerLabel.dataset.realOptionValue; // e.g. 'Original / Grey'
              return pickerLabelRealOptionValue === selectedValue;
            })[0];
            applicableVirtualPicker.click();
          }
        });
      }
    });
  }

  /**
   * Update the 'related' virtual product option pickers based on the currently
   * selected option in the 'changed' picker (that is, if 'Pillow Type' changes,
   * make sure 'Pillow Colour' is updated to only show the colours available for
   * the selected type)
   * 
   * @param {Element} changedPicker 
   */
  updateRelatedVirtualPickers(changedPicker) {
    let relatedVirtualPickers;
    let changedPickerVirtualIndex;

    switch(changedPicker.tagName) {
      // Handle 'select' virtual pickers
      case "SELECT":
        relatedVirtualPickers = Array.from(this.querySelectorAll(`[data-real-option-index='${changedPicker.dataset.realOptionIndex}']`))
          .filter(picker => picker !== changedPicker);
        changedPickerVirtualIndex = parseInt(changedPicker.dataset.virtualOptionIndex);
        relatedVirtualPickers.forEach(picker => {
          picker.querySelectorAll("option").forEach(option => {
            const realOptionValue = option.dataset.realOptionValue;
            const realOptionValueParts = realOptionValue.split(" / ");
            if(realOptionValueParts[changedPickerVirtualIndex] !== changedPicker.value) {
              option.hidden = true;
            } else {
              option.hidden = false;
            }
          });

          // The previous value may now be hidden, so pick the first non-hidden one
          if(picker.selectedOptions[0].hidden){
            picker.value = picker.querySelector("option:not([hidden])").value;
          }
        });
        break;

      // Handle 'button' virtual pickers
      case "INPUT":
        changedPickerVirtualIndex = parseInt(changedPicker.dataset.virtualOptionIndex);
        let otherPossibleVirtualIndex = changedPickerVirtualIndex === 0 ? 1 : 0;

        // Get all the buttons with the same REAL option index, but a different VIRTUAL index
        relatedVirtualPickers = Array.from(this.querySelectorAll(`[data-real-option-index='${changedPicker.dataset.realOptionIndex}']`))
          .filter(picker => picker.dataset.virtualOptionIndex != changedPickerVirtualIndex);

        console.log(this.logPrefix, `Related virtual pickers`, relatedVirtualPickers);
        console.log(this.logPrefix, 'Virtual index of changed picker', changedPickerVirtualIndex);
        console.log(this.logPrefix, 'Value of changed picker', changedPicker.value);

        // Hide the column classes containing buttons that don't match the selected button
        let handledOtherPossibleVirtualOptions = [];
        let handledChangedPickerVirtualOptions = [];

        relatedVirtualPickers.forEach(relatedPicker => {
          console.log(this.logPrefix, 'handledOtherPossibleVirtualOptions', handledOtherPossibleVirtualOptions);
          console.log(this.logPrefix, 'handledChangedPickerVirtualOptions', handledChangedPickerVirtualOptions);

          const relatedPickerLabel = relatedPicker.nextElementSibling;
          const relatedPickerRealOptionValue = relatedPickerLabel.dataset.realOptionValue;
          const relatedPickerRealOptionValueParts = relatedPickerRealOptionValue.split(" / ");

          console.log(this.logPrefix, 'relatedPickerRealOptionValueParts[changedPickerVirtualIndex]', relatedPickerRealOptionValueParts[changedPickerVirtualIndex]);
          console.log(this.logPrefix, 'Value of changed picker', changedPicker.value);

          const changedPickerLabel = changedPicker.nextElementSibling;
          const changedPickerRealOptionValue = changedPickerLabel.dataset.realOptionValue;
          const changedPickerRealOptionValueParts = changedPickerRealOptionValue.split(" / ");
          console.log(this.logPrefix, 'Related picker relatedPickerRealOptionValue', relatedPickerRealOptionValue);
          console.log(this.logPrefix, 'Changed picker changedPickerRealOptionValue', changedPickerRealOptionValue);

          let shouldHide = false;
          if(relatedPickerRealOptionValueParts[changedPickerVirtualIndex] !== changedPicker.value) {
            // The value of this 'related' picker doesn't match the value of the 'changed' picker.
            // But is it a TOTALLY DIFFERENT thing?
            // IF it's a NEW 
            if(relatedPickerRealOptionValueParts[otherPossibleVirtualIndex] !== changedPickerRealOptionValueParts[otherPossibleVirtualIndex]
              && !handledOtherPossibleVirtualOptions.includes(relatedPickerRealOptionValueParts[otherPossibleVirtualIndex])
              && !handledChangedPickerVirtualOptions.includes(relatedPickerRealOptionValueParts[changedPickerVirtualIndex])
              && relatedPicker.dataset.virtualPrimaryOption === "true") {
              handledOtherPossibleVirtualOptions.push(relatedPickerRealOptionValueParts[otherPossibleVirtualIndex]);
              console.log(this.logPrefix, "Not hiding: related picker is primary, we've not seen its other option, and it has a different other option")
            } else {
              shouldHide = true;
            }
          } else {
            if(!handledOtherPossibleVirtualOptions.includes(relatedPickerRealOptionValueParts[otherPossibleVirtualIndex])) {
              console.log(this.logPrefix, "Not hiding: related picker has same virtual value");
              handledOtherPossibleVirtualOptions.push(relatedPickerRealOptionValueParts[otherPossibleVirtualIndex]);
              handledChangedPickerVirtualOptions.push(relatedPickerRealOptionValueParts[changedPickerVirtualIndex]);
            } else {
              shouldHide = true;
            }
          }

          relatedPicker.parentElement.hidden = shouldHide;

          console.log(this.logPrefix, 'Hiding?', shouldHide);
          console.log(this.logPrefix, "====================================");
        });

        // console.log('All related pickers', relatedVirtualPickers);
        // console.log('Filtered related pickers', relatedVirtualPickers.filter(picker => picker.checked && !picker.parentElement.hidden));

        // Now set the related virtual pickers to the first available one, if not currently set
        if(relatedVirtualPickers.filter(picker => picker.checked && !picker.parentElement.hidden).length === 0) {
          // Find a match to the CURRENT virtual picker, if we have one (because now we output it)
          // console.log('changedpicker', changedPicker.dataset);
          const changedPickerLabel = changedPicker.nextElementSibling;
          const changedPickerRealOptionValue = changedPickerLabel.dataset.realOptionValue;
          const changedPickerRealOptionValueParts = changedPickerRealOptionValue.split(" / ");
          // console.log('changedPickerRealOptionValueParts', changedPickerRealOptionValueParts);
          const changedPickerVirtualIndex = parseInt(changedPicker.dataset.virtualOptionIndex);
          // console.log('changedPickerVirtualIndex', changedPickerVirtualIndex);


          let correspondingPicker = relatedVirtualPickers.filter(picker => {
            // console.log('relatedVirtualPicker value', picker.value);
            const pickerLabel = picker.nextElementSibling;
            const pickerLabelRealOptionValue = pickerLabel.dataset.realOptionValue;
            return pickerLabelRealOptionValue === changedPickerRealOptionValue;
          })[0];

          // console.log('Corresponding picker?', correspondingPicker);

          if(correspondingPicker) {
            // console.log('Found corresponding', correspondingPicker);
            // console.log('corres label', correspondingPicker.nextElementSibling);
            correspondingPicker.click();
          } else {
            // Find the first non-hidden picker
            relatedVirtualPickers.filter(picker => !picker.parentElement.hidden)[0].click();
            // console.log('Didnt find corresponding', relatedVirtualPickers.filter(picker => !picker.parentElement.hidden)[0]);
          }
        }
        break;
    }
  }
}

export default ProductVirtualOptionsPicker;